/* eslint-disable import/no-unresolved */
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { func, bool, string, shape } from "prop-types";

import Card from "pages/_components/Card/Card";
import InfoTag from "pages/_components/InfoTag";
import { getMultipleTransfersI18nKey } from "util/multiple-transfers";
import CardContainer from "pages/_components/Card/CardContainer";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import { resizableRoute } from "pages/_components/Resizable";

import { actions as notificationActions } from "reducers/notification";

import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import { truncateWithEllipsis } from "util/string";
import { itemIsClickeable } from "util/transfers";
import { getTransferActivityName } from "util/transferInternalTitleLabels";

import { SALARY_PAYMENT_ID_FORM } from "constants.js";

const getFirstNotBlank = (...values) => values.find((value) => typeof value === "string" && value.trim().length > 0);
const stripTrailingColon = (value = "") => value.replace(/:\s*$/, "");

const getEcomexBeneficiaryName = (data = {}) => {
    const transactionData = data?.transactionData || {};
    return getFirstNotBlank(
        transactionData?.beneficiaryName,
        transactionData?.nombreBeneficiario,
        data?.beneficiaryName,
        data?.nombreBeneficiario,
    );
};

class PendingTransactionsListItem extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        idForm: string.isRequired,
        activityName: string.isRequired,
        idActivity: string.isRequired,
        idTransaction: string.isRequired,
        creationDateTime: string.isRequired,
        onlyDrafts: bool.isRequired,
        idTransactionStatus: string.isRequired,
        valueDateTime: string,
        data: shape({}).isRequired,
        isEditable: bool.isRequired,
    };

    static defaultProps = {
        valueDateTime: null,
    };

    renderModifiedDate = () => {
        const { onlyDrafts, idTransactionStatus, valueDateTime, data } = this.props;
        const { scheduler } = data;

        if (onlyDrafts) {
            return null;
        }

        if (idTransactionStatus === "DRAFT") {
            return "-";
        }

        return (
            <Fragment>
                <span className="text-label mr-2">
                    {i18nUtils.get(`transactions.list.item.${idTransactionStatus}`)}
                </span>{" "}
                <span className="data-label">
                    <FormattedDate date={scheduler ? scheduler.valueDate : valueDateTime} />
                </span>
            </Fragment>
        );
    };

    onMobileItemCLick = (event) => {
        const { dispatch, idForm } = this.props;

        if (idForm === SALARY_PAYMENT_ID_FORM) {
            event.preventDefault();
            dispatch(
                notificationActions.showNotification(i18nUtils.get("massive.payments.mobile.disable"), "error", [
                    "desktop",
                ]),
            );
        }
    };

    renderRightContent = (data, activityName) => {
        const data1 = {
            amount: {
                quantity: "",
                currency: "",
            },
        };

        const hideAmount = activityName === "Comercio Exterior";
        const amount = data?.amount?.quantity
            ? data.amount.quantity
            : data.amountToShow?.quantity || data1.amount?.quantity;
        const currency = data?.amount?.currency
            ? i18nUtils.get(`currency.label.${data.amount.currency}`)
            : data.amountToShow?.currency || data1.amount?.currency;
        return (
            <div className="card__component-item-currency d-flex align-items-center">
                {!hideAmount && (
                    <div className="card__component-item-currency d-flex align-items-center">
                        <FormattedAmount currency={currency} quantity={amount} />
                    </div>
                )}
            </div>
        );
    };

    render() {
        const {
            activityName,
            idActivity,
            idTransaction,
            idTransactionStatus,
            creationDateTime,
            data,
            isEditable,
        } = this.props;

        const displayActivityName =
            idActivity === "transfer.multiple.send"
                ? i18nUtils.get(getMultipleTransfersI18nKey("activities.transfer.multiple.send"))
                : getTransferActivityName(idActivity, activityName);
        const showBeneficiaryEcomex = configUtils.getBoolean("frontend.show.beneficiary.ecomex", false);
        const beneficiaryMaxLength = configUtils.getInteger("frontend.show.beneficiary.ecomex.maxLength", 100);
        const ecomexBeneficiaryName = getEcomexBeneficiaryName(data);
        const ecomexBeneficiaryNameToShow = truncateWithEllipsis(ecomexBeneficiaryName, beneficiaryMaxLength);
        const ecomexBeneficiaryLabel = stripTrailingColon(i18nUtils.get("ecomex.transaction.card.beneficiaryName"));
        const showEcomexBeneficiary =
            activityName === "Comercio Exterior" && showBeneficiaryEcomex && !!ecomexBeneficiaryNameToShow;

        return (
            <CardContainer
                renderAs={itemIsClickeable(this.props) ? Link : "div"}
                to={!isEditable ? `/transaction/${idTransaction}` : "/desktop"}
                className="widget__card-transactions">
                <Card
                    icon={`images/transfer-${idTransactionStatus}.svg`}
                    iconClass="card__pending-transaction-icon"
                    rightArrow
                    title={
                        <div className="card__pending-transaction-data-title">
                            <div className="d-flex align-items-center">
                                <span className="card__pending-transaction-data-creation">
                                    {i18nUtils.get("transactions.list.header.creationDate")}
                                </span>
                                <FormattedDate showTime date={creationDateTime} />
                            </div>
                        </div>
                    }
                    bottom={
                        <div className="card__pending-transaction-data-bottom d-flex flex-column align-items-start">
                            <div className="d-flex align-items-center">
                                <span>{displayActivityName}</span>
                                {([
                                    "external.emit.echeq.activity",
                                    "external.emit.massive.echeq.activity",
                                    "send.external.transaction",
                                ].includes(idActivity) ||
                                    data?.externalChannel === true ||
                                    data?.channel === "externo") && (
                                    <InfoTag
                                        type="default"
                                        message={i18nUtils.get("transactions.list.external.label", "Canal externo")}
                                        tagClass="external-channel-tag"
                                        capitalize
                                    />
                                )}
                            </div>
                            {showEcomexBeneficiary && (
                                <div className="mt-1">
                                    <span className="card__pending-transaction-data-creation">
                                        {ecomexBeneficiaryLabel}{" "}
                                    </span>
                                    <span>{ecomexBeneficiaryNameToShow}</span>
                                </div>
                            )}
                        </div>
                    }
                    rightContent={this.renderRightContent(data, activityName)}
                />
            </CardContainer>
        );
    }
}

export default resizableRoute(PendingTransactionsListItem);
